import React from 'react';
import './styles.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram } from '@fortawesome/free-brands-svg-icons'

import Logo from '../../assets/img/logo.png'

export default function Footer() {
  return (
    <div className="content-footer">

      <img src={Logo} />

      <ul>
        <li>
          <a style={{color:'#fff'}}>OAB/SP: 264.652</a>
          <a style={{color:'#fff'}}>•</a>
          <a>Contato: (17) 3232-6296</a>
          <a>wagner@wjpadvogados.com.br</a>
          <a>Siga-nos nas redes sociais</a>
          <a href="https://www.facebook.com/wjpadvogado/" target="_blank" ><FontAwesomeIcon icon={faFacebook} size="2x" color="#fff" /></a>
          <a href="https://www.instagram.com/wjpadvogado/" target="_blank"><FontAwesomeIcon icon={faInstagram} size="2x" color="#fff" /></a>
        </li>
      </ul>
    </div>
  );
}
